import { render } from "./RekeningForm.vue?vue&type=template&id=20aff6ab"
import script from "./RekeningForm.vue?vue&type=script&lang=js"
export * from "./RekeningForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__